import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=2c104d66"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=2c104d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports